<template>
  <div class="video_box_s">
    <div class="video_box">
      <div class="audiotitlex">
        <div class="img_box">
          <img class="img_box" src="@/assets/icon/tupi.png" />
        </div>
        <div class="fileName_box">
          {{ fileName }}
        </div>
      </div>
      <div class="video_con">
        <el-image
          v-if="goodsFilePath"
          :src="goodsFilePath"
          :preview-src-list="imgList"
        ></el-image>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "xmlImageRead",
  data() {
    return {
      fileName: "",
      loading: null,
      goodsFilePath: "",
      srcList: [],
    };
  },
  props: {
    // filePath: {
    //   type: String,
    //   default: "",
    // },
    // fileName: {
    //   type: String,
    //   default: "",
    // },
  },
  // watch: {
  //   filePath() {
  //     this.srcList.push(this.filePath);
  //   }
  // },
  computed: {
    imgList() {
      return [this.filePath];
    },
  },
  created() {
    this.stopEvent();
    // this.tabbook();
  },
  methods: {
    //禁用右键
    stopEvent() {
      document.oncontextmenu = function (e) {
        return false;
      };
    },
    tabbook(item, index, filePath) {
      this.fileName = item.sourceName;
      this.loading = this.$loading({
        lock: true,
      });
      this.goodsFilePath = filePath;
      this.srcList.push(this.goodsFilePath);
      this.loading.close();
    },
  },
};
</script>
<style scoped lang="scss">
.video_box_s {
  overflow: hidden;
}
.video_box {
  width: 100%;
  min-height: 95vh;
  margin: 0 auto;
  box-sizing: border-box;
  overflow: hidden;
  background: #fffefd;
}

.video_boxt {
  width: 100%;
  float: left;
  font-size: 14px;
  padding: 0 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 41px;
  margin-bottom: 30px;
  height: 41px;
  border-bottom: 1px solid #f2f2f2;
}

.video_con {
  width: 500px;
  margin: 0 auto;
  margin-bottom: 30px;
  overflow: hidden;
  min-height: 430px;
  position: relative;
}
.img_box {
  width: 20px;
  height: 20px;
  background: #666666;
}
.audiotitlex {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 5px 15px;
  border-bottom: 1px solid #f2f2f2;
  padding: 5px;
}
.fileName_box {
  margin-left: 10px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 26px;
}
</style>
